import FormModal from '../FormModal'
import TransIcon from '@/assets/quick-img/zhuanchang.png'
import {Button, Checkbox, InputNumber, Popover, Tag} from "@arco-design/web-react";
import {IconClose} from "@arco-design/web-react/icon";
import React, {useEffect, useState} from "react";
import QuickCutStore from "@/stores/quickCutStore";
import { observer } from "mobx-react";
import './trans.less'
import TransitionGroup from "@/pages/VideoClips/QuickCut/Transition/TransitionGroup/TransitionGroup";
import useRequest from "@/requestHooks/mixCutDetail/useRequest";
import {getTransitionsList} from "@/services/mixCutDetail/mixCutDetail";
const ChooseTransModal = (
  {
    visible,
    handCancel,
    checkedIds,
    transIndex,
  }
) => {
  const [list, setList] = useState([]);
  const { transitions } = QuickCutStore.quickcutData
  const [duration, setDuration] = useState(transitions[transIndex]?.duration || 0.5);
  const [effects, setEffects] = useState(transitions[transIndex]?.effects || []);
  const { data } = useRequest({
    request: getTransitionsList,
  });
  const [golbal, setGolbal] = useState(false);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    if (visible) {
      setDuration(transitions[transIndex]?.duration || 0.5);
      if (transitions[transIndex]?.effects.length > 0) {
        setEffects(transitions[transIndex]?.effects);
      } else {
        transitions[transIndex] = {
          effects: [],
        }
        setEffects([])
      }
    } else {
      setGolbal(false);
      setSelectAll(false);
    }
  }, [visible]);

  useEffect(() => {
    // 当effects变化时，检查是否所有项都被选中
    if (data?.length > 0) {
      setSelectAll(effects?.length === data.length);
    }
  }, [effects, data]);

  const submit = () => {
    transitions[transIndex].duration = duration
    console.log(effects, 'effects')
    if (!golbal) { // 不应用到全局
      if (transitions[transIndex]?.effects) {
        transitions[transIndex].effects = effects
      } else {
        transitions[transIndex].effects = effects
      }
    } else {
      QuickCutStore.quickcutData.scenes.forEach((item, index) => {
        if (index !== QuickCutStore.quickcutData.scenes.length - 1) {
          QuickCutStore.quickcutData.transitions[index] = {
            duration: duration,
            effects: effects
          }
        }
      })
    }

    handCancel()
  }
  return (
    <FormModal showFooter={null} width={522} submitHandle={submit} handCancel={handCancel} icon={TransIcon} visible={visible} title="转场设置" >
      <div className={'transbox'} style={{ padding: '22px 34px' }}>
        <div className={'flex--between--center'} style={{ marginBottom: 10 }}>
          <div className="transition-timer">
            时长
            <InputNumber
              max={1}
              min={0.1}
              step={0.1}
              value={duration || 0.5}
              onChange={(e) => {
                setDuration(e)
              }}
              defaultValue={0.5}
              style={{width: 100, height: 27, margin: "0 6px"}}
            />
            秒
          </div>
          <Checkbox
            checked={selectAll}
            onChange={(checked) => {
              setSelectAll(checked);
              if (checked) {
                const allEffects = data?.map(item => ({
                  id: item.id,
                  ...item.content
                })) || [];
                setEffects(allEffects);
              } else {
                // 取消全选
                setEffects([]);
              }
            }}
          >
            全选
          </Checkbox>
          {
            effects?.length > 0 && data?.length > 0 && <div className={'total'}>
                  <span>已选择：{(effects || []).length} / 200</span>
                  <Popover
                      title=' '
                      trigger={'hover'}
                      position='br'
                      className={"chose-detail-popover-wrapper"}
                      content={
                        <div className={"chose-detail-content-wrapper"}>
                          <div className={"chose-detail-content"}>
                            { effects?.length > 0 && (effects || []).map((item) => {
                              const obj = data.find(li => li.id === item.id)
                              return (
                                <Tag
                                  key={item.id}
                                  color={"blue"}
                                  style={{margin: "2px 2px"}}
                                  className={"chose-detail-popover-item"}
                                >
                                  <span>
                                    {obj?.name}
                                    <IconClose
                                      style={{cursor: "pointer", marginLeft: 4}}
                                      onClick={() => {
                                        setEffects(prevState => prevState.filter(item => item.id !== obj.id))
                                      }}
                                    />
                                  </span>
                                </Tag>
                              );
                            })}
                          </div>
                        </div>
                      }
                  >
                      <Button type={'text'}>查看详情</Button>
                  </Popover>
                  <span onClick={() => {
                    setEffects([])
                  }} className={'clear'}>清空</span>
              </div>
          }
        </div>
        <div className={'trans-content'}>
          <TransitionGroup
            checkList={effects?.length > 0 ? effects : []}
            data={data}
            handleCheckboxChange={(e, id) => {
              console.log(e, id)
              if (e) {
                const content = data.find(item => item.id === id).content;
                if (effects) {
                  setEffects([...effects, {id, ...content}])
                } else {
                  setEffects([{id, ...content}])
                }
              } else {
                setEffects(prevState => prevState.filter(item => item.id !== id))
              }
            }}
          />
        </div>
        <div className={'trans-footer'}>
          <div>
            <Checkbox
              checked={golbal}
              style={{ marginRight: 6 }}
              onChange={(e) => {
                setGolbal(e)
              }}
            />
            应用到全部镜头
          </div>
          <div className={'flex--between--center'}>
            <Button style={{ marginRight: 20 }} onClick={() => {
              handCancel()
            }}>取消</Button>
            <Button onClick={() => {
              submit()
            }} type={'primary'}>确定</Button>
          </div>
        </div>
      </div>
    </FormModal>
  )
}
export default observer(ChooseTransModal)
